export const routes = [
  {
    path: '/mpk/account',
    name: 'PersonalAccountCochair',
    component: () => import('../views/PersonalAccountCochair.vue'),
  },
  {
    path: '/mpk/account/:id',
    name: 'AccountCochair',
    component: () => import('../views/AccountCochair.vue'),
  },
  {
    path: '/mpk/participants',
    name: 'Participants',
    component: () => import('../views/Participants.vue'),
  },
  {
    path: '/mpk/participants/:action/:id',
    name: 'ParticipantCard',
    component: () => import('../views/ParticipantCard.vue'),
  },
  {
    path: '/mpk/commissions',
    name: 'Commissions',
    component: () => import('../views/Commissions.vue'),
  },
  {
    path: '/mpk/commissions/:type/:action/:id',
    name: 'CommissionCard',
    component: () => import('../views/CommissionCard.vue'),
  },
  {
    path: '/mpk/events',
    name: 'Events',
    component: () => import('../views/Events.vue'),
  },
  {
    path: '/mpk/events/:action/:id',
    name: 'EventCard',
    component: () => import('../views/EventCard.vue'),
  },
  {
    path: '/mpk/events/add',
    name: 'EventCardAdd',
    component: () => import('../views/EventCardAdd.vue'),
  },
  {
    path: '/preparation/monitoring',
    name: 'AssignmentMonitoring',
    component: () => import('../views/AssignmentMonitoring.vue'),
  },
  {
    path: '/mpk/assignments',
    name: 'Assignments',
    component: () => import('../views/Assignments.vue'),
  },
  {
    path: '/mpk/assignments/:action/:id',
    name: 'AssignmentCard',
    component: () => import('../views/AssignmentCard.vue'),
  },
  {
    path: '/mpk/events/request/:id',
    name: 'EventRequestForm',
    component: () => import('../views/EventRequestForm.vue'),
  },
  {
    path: '/Preparation/Requests',
    name: 'EventRequests',
    component: () => import('../views/EventRequests.vue'),
  },
  {
    path: '/preparation/requests/view/:id',
    name: 'EventRequestView',
    component: () => import('../views/EventRequestView.vue'),
  },
  {
    path: '/business-tips',
    name: 'business-tips',
    component: () => import('../views/BusinessTips.vue'),
  },
  {
    path: '/business-tips/:id/:type',
    name: 'card-business-tips',
    component: () => import('../views/CardBusinessTips.vue'),
  },
];
